import { render } from "./TableProdutoAndMateria.vue?vue&type=template&id=2f5761c6"
import script from "./TableProdutoAndMateria.vue?vue&type=script&lang=js"
export * from "./TableProdutoAndMateria.vue?vue&type=script&lang=js"

import "./TableProdutoAndMateria.vue?vue&type=style&index=0&id=2f5761c6&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__